import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import router from ".";
import { installButtonClickDebounce } from "@/utils/button-click-debounce";
import { initializeLocale } from "@/utils/i18n";
import "../app/globals.css";

installButtonClickDebounce(500);
// 저장된 언어 설정이 없으면 접속자의 지역을 기준으로 언어를 결정한다.
initializeLocale();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />,
);
